var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('proposal-form',{attrs:{"campaign":_vm.campaign,"proposal":_vm.proposal},on:{"proposal-complete":_vm.finish,"request-error":_vm.handleRequestError,"notify-error":_vm.handleNotifyError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }